import React from "react";
import "../styles/taggrid.css";

const TagGrid = ({ tags }) => {
    return (
        <div className="tag-grid">
            {tags.map((tag, index) => (
                <div key={index} className="tag-item">
                    <img src={tag.image} alt={tag.text} className="tag-image" />
                    {tag.text}
                </div>
            ))}
        </div>
    );
};

export default TagGrid;
